import { TabButtonsGroup } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { DemoInvoiceView } from '../../enums/demoInvoiceView'
import { useTrackDemoInvoiceEditor } from '../../hooks/useTrackDemoInvoiceEditor'

interface DemoInvoiceViewToggleProps {
  onChange: (view: DemoInvoiceView) => void
  view: DemoInvoiceView
}

export const DemoInvoiceViewToggle = ({ onChange, view }: DemoInvoiceViewToggleProps): ReactElement => {
  const { t } = useTranslation()
  const { trackDemoInvoiceEditor } = useTrackDemoInvoiceEditor()

  const handleViewClick = useCallback(
    (selectedView: DemoInvoiceView) => {
      trackDemoInvoiceEditor('Editor/Preview toggle clicked', { selectedOption: selectedView })
      onChange(selectedView)
    },
    [onChange, trackDemoInvoiceEditor],
  )

  const handleEditorClick = useCallback(() => {
    handleViewClick(DemoInvoiceView.Editor)
  }, [handleViewClick])

  const handlePreviewClick = useCallback(() => {
    handleViewClick(DemoInvoiceView.Preview)
  }, [handleViewClick])

  return (
    <TabButtonsGroup>
      <TabButtonsGroup.Button icon="squarePen" onClick={handleEditorClick} selected={view === DemoInvoiceView.Editor}>
        {t('external_invoices.editor.tab.editor')}
      </TabButtonsGroup.Button>
      <TabButtonsGroup.Button icon="eye" onClick={handlePreviewClick} selected={view === DemoInvoiceView.Preview}>
        {t('external_invoices.editor.tab.preview')}
      </TabButtonsGroup.Button>
    </TabButtonsGroup>
  )
}
